import { render, staticRenderFns } from "./AttachAddressModal.vue?vue&type=template&id=6113910c&scoped=true&"
import script from "./AttachAddressModal.vue?vue&type=script&lang=js&"
export * from "./AttachAddressModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6113910c",
  null
  
)

export default component.exports